import { SET_CREATE_CLIENT_FROM } from 'src/actions/actionTypes'

export const setCreateClientFrom = from => {
  return {
    type: SET_CREATE_CLIENT_FROM,
    data: { from }
  }
}
